import festivalConfig from '../../configs/festival-config'

const initFestivalStyle = function () {
	if (festivalConfig.newYear) {
		document.body.classList.add('fx-new-year')
	} else if (festivalConfig.chineseNewYear) {
		document.body.classList.add('fx-chinese-new-year')
	} else if (festivalConfig.spring) {
		document.body.classList.add('fx-spring-season')
	} else if (festivalConfig.lantern) {
		document.body.classList.add('fx-lantern-season')
	} else if (festivalConfig.goddess) {
		document.body.classList.add('fx-goddess-day')
	} else if (festivalConfig.labourDay) {
		document.body.classList.add('fx-labour-day')
	} else if (festivalConfig.dragonBoat) {
		document.body.classList.add('fx-dragon-boat')
	} else if (festivalConfig.armyBuilding) {
		document.body.classList.add('fx-army-building')
	} else if (festivalConfig.midAutumn) {
		document.body.classList.add('fx-mid-autumn')
	} else if (festivalConfig.national) {
		document.body.classList.add('fx-national-day')
	} else if (festivalConfig.merryChristmas) {
		document.body.classList.add('fx-merry-christmas')
	} else if (festivalConfig.releaseSkin) {
		document.body.classList.add('fx-release-skin')
	}
}
export default {
	initFestivalStyle
}



// WEBPACK FOOTER //
// ./src/lib/festival/index.js